module.exports = __webpack_public_path__ + "img/payback_light-webfont.d87fce62.svg";